import PropTypes from "prop-types";
import DocViewer, { DocViewerRenderers } from "react-doc-viewer";
import CustomPDFRenderer from "../../components/search/document-search/custom-pdf-renderer";

const FeeScheduleDoc = ({ content }) => {
    return (
        content && (
            <DocViewer
                pluginRenderers={[CustomPDFRenderer, ...DocViewerRenderers]}
                documents={[
                    {
                        uri: content.contentImageUrl,
                        fileType: content.contentImageUrl.split(".").pop().toLowerCase()
                    }
                ]}
                config={{ header: { disableHeader: true } }}
                style={{ backgroundColor: "white" }}
            />
        )
    );
};

FeeScheduleDoc.propTypes = {
    content: PropTypes.shape({
        contentImageUrl: PropTypes.string.isRequired
    }).isRequired
};

export default FeeScheduleDoc;
